import React from 'react'
import DrilldownTable from '../../../Components/Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTable'
import moment from 'moment';
import { AppConstant } from '../../../../../Assests/AppConstant';
import { getUserSelector } from '../../../../../../redux/reducers/reducerSlices/UserReducer';
import { useSelector } from 'react-redux';

const UploadList = (props) => {
    const { themeSelected,bodyData,loading } = props;
      const user = useSelector(getUserSelector);
              const { userType } = user

    const headerslist = [
        { id: '', name: "S.No" },
        { id: 'sessionId', name: "Session ID" },
        { id: 'PoNumber', name: "PO No." },
        { id: 'AppointmentNo', name: "Appointment No." },
        { id: 'VendorName', name: "Vendor Name" },
        { id: 'carrier', name: "Carrier Name" },
        { id: 'Scheduledate', name: "Schedule Date" },
        { id: 'Cases', name: "Cases" },
        { id: 'Items', name: "Items" },
        { id: 'Commodity', name: "Commodity" }
    ]

     const formatListDataDrillDown = (data) => {
        return data.map((el, index) => {
                return {
                   0: index + 1,
                    1: el.SessionId || "-",
                    2: el.PONumber || "-",
                    3: el.AppointmentConfirmationNumber || "-",
                    4: el.Vendor || "-",
                    5: el.Carrier || "-",
                    6: el.TruckDate ? moment(el.TruckDate).format(AppConstant.commonStrings.MM_DD_YYYY__HH_mm) : "-",
                    7: el.Cases || "-",
                    8: el.Items || "-",
                    9: el.Commodity || "-",
                 }
            })
    }

  return (
   <div className=''>
            {
                <div>
                    <div className="eclipseOpsListContainer" style={{ maxHeight: userType === "SUPERADMIN" ? "55vh" : "65vh" }}>
                        <DrilldownTable
                            themeSelected={themeSelected}
                            bodyData={formatListDataDrillDown(props.bodyData)}
                            titleData={headerslist}
                             initiateDrillDownReport={loading || false}
                            loaderArray={10}
                            showCollapse={false}
                            showInput={false}
                           drillDownReport={props.bodyData}
                           subRoot={{ pathName: 'poSSList' }}
                            showUTCTime={false}
                        />
                    </div>
                   
                </div>
            }
        </div>
  )
}

export default UploadList